module.exports = __webpack_public_path__ + "static/media/folha1.cd1ca671.png";